import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteContractDetail,
  deletePolicyHolderInsuree,
  fetchContractDetails,
  fetchPolicyHolderByInsuree,
  loadingUser,
  printInsureeReport,
} from "../../action";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import {
  Button,
  Grid,
  Typography,
  Paper,
  IconButton,
  Input,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TableN from "../../reusableComponents/components/generics/TableN";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DialogBox from "../../reusableComponents/components/dialogs/DialogBox";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";

import { styled } from "@mui/system";
import AddInsureeContractDialog from "./contractDialog/AddInsureeContractDialog";
import { apiHeaders, decodeId } from "../../utils/helper";
import UpdateContractDialog from "./contractDialog/UpdateContractDialog";
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function ContractDetailsTable({ policyHolderId, filter, setInsureeData }) {
  const SignInSuccess = useSelector((state) => state);
  const contractStatus = SignInSuccess?.profileReducer?.contracts?.[0]?.state;
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [printData, setPrintData] = useState();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [insureeToDelete, setInsureeToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  const [pickerPolicyHolderInsurees, setPickerPolicyHolderInsurees] =
    useState();

  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    params.push(`isDeleted: false`);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy:["insuree"]`);
    }
    if (!!state.policyHolderId) {
      params.push(`contract_Id: "${state.policyHolderId}"`);
    }
    return params;
  };

  let params;

  
  // const fetchContractDetails = async () => {
  //   params = buildQueryParams({
  //     filters: filter,
  //     pageSize,
  //     beforeCursor: endCursors,
  //     afterCursor: startCursors,
  //     orderBy: ["insuree"],
  //     policyHolderId: policyHolderId,
  //   });
  //   dispatch(fetchContractDetails(params));
  // };

  useEffect(() => {
    params = buildQueryParams({
      filters: filter,
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
      orderBy: ["insuree"],
      policyHolderId: policyHolderId,
    });
    if (policyHolderId) {
      dispatch(fetchContractDetails(params));
    }
  }, [policyHolderId, page, pageSize]);

  useEffect(() => {
    if (SignInSuccess?.profileReducer?.contractDetails) {
      setPolicyHolderData(SignInSuccess?.profileReducer?.contractDetails);
      setInsureeData(SignInSuccess?.profileReducer?.contractDetails);
      setPageInfo(
        SignInSuccess?.profileReducer?.contractDetailsPageInfo.totalCount
      );
      setStartCursors(
        SignInSuccess?.profileReducer?.contractDetailsPageInfo?.endCursor
      );
      setEndCursors(
        SignInSuccess?.profileReducer?.contractDetailsPageInfo?.startCursor
      );
    }
  }, [SignInSuccess]);

  const openAddInsureeDailog = () => {
    setShowDialog(!showDialog);
  };

  const handleEdit = (rowData) => {
    setShowUpdateDialog(true);
    setRowDataForEdit(rowData);
  };

  const handleDeleteClick = (rowData) => {
    setInsureeToDelete(rowData);
    setDeleteDialogOpen(true);
  };

  const handleDeleteAgree = async () => {
    params = buildQueryParams({
      filters: filter,
      pageSize,
      orderBy: ["insuree"],
      policyHolderId: policyHolderId,
    });
    dispatch(deleteContractDetail(insureeToDelete?.id));
    setDeleteDialogOpen(false);
    dispatch(fetchContractDetails(params));
  };

  const headers = () => {
    var h = [
      t("Insuree Name"),
      t("Camu No."),
      t("Temporary CAMU No./CAMU No."),
      t("ContributionPlanBundle"),
      t("Gross Salary"),
      t("Employer's Contribution"),
      t("Salary Share"),
      t("Total"),
      t("Action"),
    ];

    return h;
  };

  const itemFormatters = () => {
    var row = [
      (policyHolderInsuree) =>
        !!policyHolderInsuree.insuree
          ? `${policyHolderInsuree.insuree.lastName}-${policyHolderInsuree.insuree.otherNames}`
          : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree.insuree.camuNumber
          ? `${policyHolderInsuree.insuree.camuNumber}`
          : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree.insuree
          ? `${policyHolderInsuree.insuree.chfId}`
          : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree.contributionPlanBundle
          ? `${policyHolderInsuree.contributionPlanBundle?.code} - ${policyHolderInsuree.contributionPlanBundle?.name}`
          : "",
      (policyHolderInsuree) => {
        const { lastPolicy, ...others } = policyHolderInsuree;
        const policy = !!lastPolicy ? lastPolicy : {};
        const jsonData = JSON.parse(policyHolderInsuree.jsonExt);
        const income = jsonData?.calculation_rule?.income;
        return !!policyHolderInsuree.jsonExt ? income : "";
      },
      (contractDetails) =>
        !!contractDetails.customField
          ? contractDetails?.customField.includes("employerContribution")
            ? JSON.parse(contractDetails.customField.replace(/'/g, '"'))
                ?.employerContribution
            : ""
          : "",
      (contractDetails) =>
        !!contractDetails.customField
          ? contractDetails.customField.includes("salaryShare")
            ? JSON.parse(contractDetails.customField.replace(/'/g, '"'))
                .salaryShare
            : ""
          : "",
      (contractDetails) =>
        !!contractDetails.customField
          ? contractDetails.customField.includes("total")
            ? JSON.parse(contractDetails.customField.replace(/'/g, '"')).total
            : ""
          : "",

      (policyHolderData, idx) => (
        <>
          <Grid display={"flex"}>
            {/* <IconButton
              onClick={() => handleEdit(policyHolderData)}
              disabled={contractStatus == 4 || contractStatus == 5}
            >
              <EditIcon />
            </IconButton> */}
            <IconButton
              onClick={() => handleDeleteClick(policyHolderData)}
              disabled={contractStatus == 4 || contractStatus == 5}
            >
              <DeleteForeverIcon />
            </IconButton>
          </Grid>
        </>
      ),
    ];
    return row;
  };
  const handleInsureeDownload = async () => {
    let encodedCode = encodeURIComponent(policyHolderId);
    let url_import = `${process.env.REACT_APP_BACKEND_URL}/api/contract/export/${encodedCode}/contracts`;
    try {
      const response = await fetch(url_import, {
        headers: apiHeaders,
        method: "GET",
        credentials: "same-origin",
      });
      if (response.status >= 400) {
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = this.userlang === "fr" ? "liste des assurées Ouvrant droit.xlsx" : "policyholder_insurees.xlsx";
      a.download = "contract.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      alert(
        error?.message ??
            `An error occurred. Please contact your administrator. ${error?.message}`
      );
    }
  };
  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };

  const onSubmit = async (values) => {
    const value = {
      values,
      contributionPlanBundle:
        pickerPolicyHolderInsurees?.[0]?.contributionPlanBundle,
      contractId: policyHolderId,
      jsonExt: { calculation_rule: { income: values.income, rate: 0 } },
    };
    params = buildQueryParams({
      filters: filter,
      pageSize,
      orderBy: ["insuree"],
      policyHolderId: policyHolderId,
    });

    if (SignInSuccess?.profileReducer?.mutations?.[0]?.error == null) {
      setShowDialog(false);
      dispatch(fetchContractDetails(params));
    }
  };
  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">
                {t("Insuree")}-{pageInfo}
              </Typography>
            </Grid>
            <Grid style={{ marginLeft: "auto", display: "flex" }}>
              <Button
                onClick={handleInsureeDownload}
                color="primary"
                variant="outlined"
                startIcon={<SaveAltRoundedIcon />}
                style={{ backgroundColor: "#fff" }}
              >
                {t("Insuree")}
              </Button>
              <Button
                onClick={openAddInsureeDailog}
                color="primary"
                variant="outlined"
                disabled={contractStatus == 4  || contractStatus == 5}
                startIcon={<AddIcon />}
                style={{ marginLeft: ".5rem", backgroundColor: "#fff" }}
              >
                {t("Add Insuree")}
              </Button>
            </Grid>
          </StyledPaperHeader>
          <TableN
            module="insuree"
            headers={headers()}
            // headerActions={headerActions}
            itemFormatters={itemFormatters()}
            items={policyHolderData ? policyHolderData : []}
            // error={!!errorFullfamilyPendingApproval ? errorFullfamilyPendingApproval : null}
            withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            // rowLocked={this.rowLocked}
          />
        </StyledPaper>
      </Grid>
      {
        <AddInsureeContractDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          currentUser={currentUser}
          contractId={
            SignInSuccess?.profileReducer?.contracts &&
            SignInSuccess?.profileReducer?.contracts?.[0]?.id
          }
          onSubmit={onSubmit}
          pickerPolicyHolderInsurees={pickerPolicyHolderInsurees}
          setPickerPolicyHolderInsurees={setPickerPolicyHolderInsurees}
        />
      }
      {showUpdateDialog && (
        <UpdateContractDialog
          rowDataForEdit={rowDataForEdit}
          showUpdateDialog={showUpdateDialog}
          setShowUpdateDialog={setShowUpdateDialog}
          contractId={policyHolderId}
        />
      )}
      {deleteDialogOpen && (
        <DialogBox
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onAgree={handleDeleteAgree}
          title={t("Confirmation")}
          content={`${t("Are you sure you want to delete? Insuree")} - ${
            insureeToDelete?.insuree?.otherNames
          }`}
          agreeLabel={t("delete")}
          disagreeLabel={t("Cancel")}
        />
      )}
    </Grid>
  );
}

export default ContractDetailsTable;
